"use client";

import dayjs from "dayjs";
import { PropsWithChildren, useEffect, type JSX } from "react";
import {
  COOKIE_PATH,
  newFeatureFlagsSessionId,
  REFRESH_RATE,
  SESSION_ID_KEY,
  TIME_TO_LIVE,
} from "./featureSessionFlag";

function readFromCookie() {
  if (globalThis.document === null || globalThis.document === undefined)
    return undefined;
  const value = document.cookie
    .split("; ")
    .find((row) => row.startsWith(SESSION_ID_KEY))
    ?.split("=")[1];
  return value !== null && value !== undefined && value !== ""
    ? decodeURIComponent(value)
    : undefined;
}

function writeToCookie(sessionId: string) {
  if (globalThis.document === null || globalThis.document === undefined) return;
  document.cookie = `${SESSION_ID_KEY}=${sessionId}; expires=${dayjs()
    .add(TIME_TO_LIVE)
    .toDate()
    .toUTCString()}; path=${COOKIE_PATH}`;
}

export function startNewFeatureFlagsSession() {
  const sessionId = newFeatureFlagsSessionId();
  writeToCookie(sessionId);
  return sessionId;
}

export const getFeatureFlagsSessionId = () => {
  const sessionId = readFromCookie() ?? startNewFeatureFlagsSession();
  return sessionId;
};

const extendSession = () => {
  writeToCookie(getFeatureFlagsSessionId());
};

// Extends the LD Session as long as the user interacts with the app
export const FeatureFlagsSessionIdRefresher = ({
  children,
}: PropsWithChildren): JSX.Element => {
  const isBrowser =
    globalThis.document !== null && globalThis.document !== undefined;

  useEffect(() => {
    if (!isBrowser) return;

    const interval = setInterval(extendSession, REFRESH_RATE.asMilliseconds());
    return () => clearInterval(interval);
  }, [isBrowser]);

  return children as JSX.Element;
};
